import { Button, Typography } from '@mui/material';

type Props = {
  number: string;
};

function ClickablePhoneNumber({ number }: Props) {
  return (
    <Typography variant="body2">
      <Button
        href={`tel:${number}`}
        variant="text"
        className="text-btn external-link">
        {number}
      </Button>
    </Typography>
  );
}

export default ClickablePhoneNumber;
